module.exports = __webpack_public_path__ + "img/pgaziendale.b3c75be3.png";